import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Switch from 'app/scripts/components/common/inputs/customs/switch';
import { autobind } from 'core-decorators';
import { withEditSpot } from '../../../spots/hoc/withEditSpot';

class EnableRichSayControl extends Component {
  static defaultProps = {
    value: true
  };

  static propTypes = {
    value: PropTypes.bool.isRequired,
    spotId: PropTypes.string.isRequired
  };

  static displayName = 'EnableRichSayControl';

  @autobind
  onChange(value) {
    if (value !== this.props.value) {
      this.props.editSpot(this.props.spotId, { rich_say_control_enabled: value });
    }
  }

  render() {
    return (
      <div>
        <Switch
          title="Rich-Text Input"
          description="Allow the use of advanced text formatting in comments. "
          value={this.props.value}
          onChange={this.onChange}
        />
      </div>
    );
  }
}

export default withEditSpot(EnableRichSayControl);
